import { NotificationAlertOverride } from ".";
import { AnyNotificationContext } from "../../Notifications";

export const BankingVerified: NotificationAlertOverride<
  AnyNotificationContext
> = () => ({
  theme: "success",
  icon: "check-circle"
});
